import React from 'react';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

export default function Button({ btnText, variant, icon }) {
  return (
    <HashLink
      id='arc'
      className={variant ? `cs-text_btn ${variant}` : 'cs-text_btn'}
    >
      <>
        <span>{btnText}</span>
        {icon ? icon : <Icon icon="bi:arrow-right" />}
      </>
    </HashLink>
  );
}
